import { __assign, __extends } from "tslib";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/journal.scss';
var JournalViewer = /** @class */ (function (_super) {
    __extends(JournalViewer, _super);
    function JournalViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.theme = mergeTheme(baseTheme, _this.props.theme);
        return _this;
    }
    JournalViewer.prototype.render = function () {
        var restProps = omit(this.props, ['theme']);
        return (React.createElement("div", { className: 'da-editor-journal' },
            React.createElement(BaseViewer, __assign({ theme: this.theme, fixedParagraph: true }, restProps))));
    };
    return JournalViewer;
}(React.Component));
export default JournalViewer;
//# sourceMappingURL=Journal.js.map